import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  activeItem: null,
  refreshTrigger: 0,
  totalCount: 0,
}

export const cardsSlice = createSlice({
  name: 'cards',
  initialState,
  reducers: {
    setactiveItem: (state, action) => {
      state.activeItem = action.payload
    },
    setRefreshTrigger: (state, action) => {
      if (action.payload) {
        state.refreshTrigger = action.payload;
      } else {
        state.refreshTrigger = state.refreshTrigger + 1
      }
    },
    setTotalCount: (state, action) => {
      state.totalCount = action.payload
    }
  },
})

export const { setactiveItem, setRefreshTrigger, setTotalCount } = cardsSlice.actions

export default cardsSlice.reducer;
